import { FC, ImgHTMLAttributes, useMemo } from 'react'

type ImgResponsiveProps =
  & ImgHTMLAttributes<HTMLImageElement>
  & {
    src: string
    maxDensity?: number
  }

export const ImgResponsive: FC<ImgResponsiveProps> = (props) => {
  const { src, maxDensity = 2, ...restProps } = props

  const srcSet = useMemo(() => {
    const parts = src.match(/^(.*)\.([^.]+)$/)
    if (!parts) {
      return
    }

    const [, filename, ext] = parts

    const count = maxDensity - 1
    return new Array(count).fill(0).map((_, index) => {
      const density = index + 2
      return `${ filename }@${ density }x.${ ext } ${ density }x`
    }).join(', ')
  }, [maxDensity, src])

  return (
    <img src={ src } srcSet={ srcSet } { ...restProps } />
  )
}
